import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { protectedRoute } from "@/utils/routeUtils";
import RouteTypeValidation from "../components/RouteTypeValidation";

const moduleTitle = "module_title.employee_review_management";
const allowedRoles = ["isOnboardingViewer", "isVisaReviewer"];
const allowedTypes = ["reviewed", "rejected", "pending"];

export const RedirectToList = () => {
  const userRoles = useSelector((state) => state.auth?.userRoles);
  const navigate = useNavigate();

  useEffect(() => {
    if (userRoles?.length > 0)
      navigate("/employee-review/pending", { replace: true });
  }, [userRoles, navigate]);

  return null;
};

const RedirectToEmployeeBasicInfo = () => {
  const { id } = useParams();

  return <Navigate to={`/employee-review/${id}/employee-basic-info`} replace />;
};

const employeeRoutes = {
  path: "employee-review",
  title: moduleTitle,
  sidebarProps: {
    key: "1-15",
    iconSrc: "employee-review",
    label: "module_title.employee_review",
    link: "/employee-review",
    groupingType: "TOOLS",
    order: 15,
    permissions: allowedRoles,
  },
  element: null,
  children: [
    {
      index: true,
      path: "",
      title: moduleTitle,
      element: <RedirectToList />,
    },
    {
      path: ":type",
      title: moduleTitle,
      children: [
        {
          index: true,
          path: "",
          element: (
            <RouteTypeValidation
              allowedTypes={allowedTypes}
              fallback={protectedRoute(
                [
                  () => import("@/pages/employee-review/EmployeeReview"),
                  () => import(`@/pages/employee-review/EmployeeReviewList`),
                ],
                allowedRoles
              )}
            />
          ),
        },
        {
          path: ":id",
          title: moduleTitle,
          children: [
            {
              index: true,
              path: "",
              headerProps: { backUrl: "/employee-review/:type" },
              element: <RedirectToEmployeeBasicInfo />,
            },
            {
              path: "employee-basic-info",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/employee-basic-info/EmpRevEmployeeBasicInfo"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
            {
              path: "passport-visa-info",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/passport-visa-info/EmpRevPassportVisaInfo"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
            {
              path: "spouse-visa-info",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/spouse-visa-info/EmpRevSpouseVisaInfo"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
            {
              path: "dependant-visa-info",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/dependant-visa-info/EmpRevDependantVisaInfo"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
            {
              path: "employment-info",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/employment-info/EmpRevEmploymentInfo"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
            {
              path: "supporting-document",
              title: moduleTitle,
              headerProps: { backUrl: "/employee-review/:type" },
              element: (
                <RouteTypeValidation
                  allowedTypes={allowedTypes}
                  fallback={protectedRoute(
                    [
                      () =>
                        import("@/pages/employee-review/EmployeeReviewDetails"),
                      () =>
                        import(
                          "@/pages/employee-review/supporting-document/EmpRevSupportingDocument"
                        ),
                    ],
                    allowedRoles
                  )}
                />
              ),
            },
          ],
        },
      ],
    },
  ],
};

export default employeeRoutes;
